var map = {
	"./CanvasClear": 39,
	"./CanvasClear.js": 39,
	"./CanvasMove": 40,
	"./CanvasMove.js": 40,
	"./CommandAbstract": 19,
	"./CommandAbstract.js": 19,
	"./ComponentDelete": 41,
	"./ComponentDelete.js": 41,
	"./ComponentDrag": 42,
	"./ComponentDrag.js": 42,
	"./ComponentEnter": 43,
	"./ComponentEnter.js": 43,
	"./ComponentExit": 44,
	"./ComponentExit.js": 44,
	"./ComponentNext": 45,
	"./ComponentNext.js": 45,
	"./ComponentPrev": 46,
	"./ComponentPrev.js": 46,
	"./ComponentStyleClear": 47,
	"./ComponentStyleClear.js": 47,
	"./CopyComponent": 48,
	"./CopyComponent.js": 48,
	"./DeleteComponent": 49,
	"./DeleteComponent.js": 49,
	"./ExportTemplate": 50,
	"./ExportTemplate.js": 50,
	"./Fullscreen": 51,
	"./Fullscreen.js": 51,
	"./MoveComponent": 52,
	"./MoveComponent.js": 52,
	"./OpenAssets": 53,
	"./OpenAssets.js": 53,
	"./OpenBlocks": 54,
	"./OpenBlocks.js": 54,
	"./OpenLayers": 55,
	"./OpenLayers.js": 55,
	"./OpenStyleManager": 56,
	"./OpenStyleManager.js": 56,
	"./OpenTraitManager": 57,
	"./OpenTraitManager.js": 57,
	"./PasteComponent": 58,
	"./PasteComponent.js": 58,
	"./Preview": 59,
	"./Preview.js": 59,
	"./Resize": 60,
	"./Resize.js": 60,
	"./SelectComponent": 14,
	"./SelectComponent.js": 14,
	"./SelectPosition": 25,
	"./SelectPosition.js": 25,
	"./ShowOffset": 61,
	"./ShowOffset.js": 61,
	"./SwitchVisibility": 62,
	"./SwitchVisibility.js": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;